import React, {useMemo} from 'react';
import classNames from 'classnames';
import { Bubble } from 'tea-component';
import DatalabGrid from '@/pages/datalab/components/DatalabGrid';
import LabelText from '@/pages/datalab/components/LabelText';
import './index.scss';

interface IMetricVsBubbleDataItem {
  leftTitle: React.ReactNode | Element;
  rightTitle: React.ReactNode | Element;
  thisTime?: string | number | null;
  lastTime?: string | number | null;
  thisValue?: string | number | null | React.ReactNode;
  lastValue?: string | number | null | React.ReactNode;
}

type TBubbleProps = React.ComponentProps<typeof Bubble>;

interface IMetricVsBubbleProps extends Omit<TBubbleProps, 'content'> {
  data: IMetricVsBubbleDataItem[];
  contentTitle?: string;
}

const MetricVsBubble: React.FC<IMetricVsBubbleProps> = ({
  data,
  contentTitle,
  overlayClassName,
  children,
  ...rest
}) => {
  const content = useMemo(() => {
    const body = data?.length > 0
      ? data?.map((info, index) => {
        const { leftTitle, rightTitle, thisTime, lastTime, thisValue, lastValue } =
        info || {};
        return (
          <React.Fragment key={index}>
            <DatalabGrid.Item
              className="dbl-metric-vs__item-header"
            >
              {leftTitle}
            </DatalabGrid.Item>
            <div></div>
            <DatalabGrid.Item className="dbl-metric-vs__item-header" align={'end'}>
              {rightTitle}
            </DatalabGrid.Item>
            <DatalabGrid.Item className="dbl-metric-vs__item-body-text">
              <div className="dbl-metric-vs__item-body-this">
                {thisTime || '-'}
              </div>
              <div className="dbl-metric-vs__item-body-last">
                {lastTime || '-'}
              </div>
            </DatalabGrid.Item>
            <DatalabGrid.Item
              className="dbl-metric-vs__item-body-vs"
              verticalAlign="center"
              align={'center'}
            >
              VS
            </DatalabGrid.Item>
            <DatalabGrid.Item className="dbl-metric-vs__item-body-text" align={'end'}>
              <div className="dbl-metric-vs__item-body-this">
                {thisValue || '-'}
              </div>
              <div className="dbl-metric-vs__item-body-last">
                {lastValue || '-'}
              </div>
            </DatalabGrid.Item>
          </React.Fragment>
        );
      })
      : undefined;
    if (!body) return null;
    
    const bodyWrap = <DatalabGrid
      colCount={3}
      gap={10}
      rowGap={16}
      className="dbl-metric-vs__item-content"
      columnWidthMode={['max-content', '22px', 'max-content']}
    >
      {body}
    </DatalabGrid>;
    
    if (contentTitle) {
      return (<DatalabGrid
        colCount={1}
        columnWidthMode={'minmax(0, min-content)'}
      >
        <LabelText preset="838697-14-400">
          {contentTitle}
        </LabelText>
        {bodyWrap}
      </DatalabGrid>);
    }
    
    return bodyWrap;
    
  }, [data, contentTitle]);

  return (
    <Bubble
      trigger="hover"
      dark
      overlayClassName={classNames('dbl-metric-vs-bubble', overlayClassName)}
      content={content}
      {...rest}
    >
      {children}
    </Bubble>
  );
};

export default MetricVsBubble;